import { ArrowDownIcon } from '~/icons';

export const MuiSelect = {
  defaultProps: {
    fullWidth: true,
    IconComponent: ArrowDownIcon,
    variant: 'outlined',
    displayEmpty: true,
    MenuProps: {
      PaperProps: {
        sx: {
          maxHeight: 400,
        },
      },
    },
  },
  styleOverrides: {
    icon: {
      top: 'auto',
      color: '#1010EB',
    },
    root: {
      '&.Mui-disabled': {
        backgroundColor: '#DCDCDC',
      },
      backgroundColor: '#fff',
    },
    select: {
      paddingRight: '44px !important',
    },
  },
};
